import React from "react";
import { Job as JobItem } from "./Job";
import CurrentUser from "../../apiResources/CurrentUser";
import Job from "../../apiResources/Job";

const JobItemCardStyleOverrides = {
  border: "1px solid #e6e6e6",
  padding: "1rem",
  marginBottom: "1rem",
  borderRadius: "5px",
  width: "100% !important",
  position: "relative",
};

const JobListCard = (props: Props) => {
  const { job, user, onDelete } = props;

  return (
    <JobItem
      job={job}
      feedbacks={job.feedbacks}
      isRootParentEmployer={user.isRootParentEmployer}
      style={JobItemCardStyleOverrides}
      onDelete={onDelete}
    />
  );
};

type Props = {
  job: Job;
  user: CurrentUser;
  onDelete: (jobId: string) => void;
};

export default JobListCard;
